import { Controller } from "@hotwired/stimulus"

// Phase 2.5 Tier 3 — Capital Request scoring panel. Updates the
// per-criterion slider value display and the running weighted-total
// preview as evaluators move the sliders. Server is authoritative on
// save; this is purely a live-feedback UX affordance.
export default class extends Controller {
  static targets = ["value", "weightedTotal"]
  static values = { criteria: Array } // [{ id, weight, scale_min, scale_max }, ...]

  connect() {
    this._scores = {}
    // Pre-fill from existing slider values so the weighted total reflects
    // the saved state on first render.
    this.valueTargets.forEach(el => {
      const id = parseInt(el.dataset.criterionId, 10)
      const slider = this._sliderFor(id)
      if (slider) this._scores[id] = parseFloat(slider.value || 0)
    })
    this._refreshTotal()
  }

  updateValue(event) {
    const slider = event.target
    const id = parseInt(slider.dataset.criterionId, 10)
    const value = parseFloat(slider.value || 0)
    this._scores[id] = value

    const display = this.valueTargets.find(el => parseInt(el.dataset.criterionId, 10) === id)
    if (display) display.textContent = String(slider.value)

    this._refreshTotal()
  }

  _refreshTotal() {
    if (!this.hasWeightedTotalTarget) return
    const total = (this.criteriaValue || []).reduce((acc, c) => {
      const score = this._scores[c.id] || 0
      return acc + (score * (c.weight || 0))
    }, 0)
    this.weightedTotalTarget.textContent = total.toFixed(2)
  }

  _sliderFor(id) {
    return this.element.querySelector(`input[type="range"][data-criterion-id="${id}"]`)
  }
}
